exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.tab-label[data-v-4be11a51]{max-width:204px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}span.alert-notification[data-v-4be11a51]{position:absolute;width:20px;height:20px;background:#d40000;right:0;top:5px;color:#fff;text-align:center;border-radius:50%}", ""]);

// exports
